import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles, categories, featuredVideos, hotTags } from '@/mocks/articles';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState('all');

  const featuredArticle = articles.find((a) => a.id === 5) || articles[0];
  const hotArticles = articles.filter((a) => a.isHot);
  const latestArticles = articles.filter((a) => a.isNew);
  const filteredArticles = activeCategory === 'all'
    ? articles
    : articles.filter((a) => a.category === activeCategory);

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-950">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full">
            <div className="relative h-[520px] md:h-[640px] w-full overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=dark%20dramatic%20cityscape%20at%20night%20with%20neon%20red%20and%20pink%20lights%2C%20futuristic%20urban%20environment%2C%20mysterious%20atmosphere%2C%20cinematic%20photography%2C%20dark%20moody%20vibe%2C%20rain%20slicked%20streets%20reflecting%20neon%2C%20noir%20aesthetic&width=1920&height=800&seq=hero-bg-2026&orientation=landscape"
                alt="51吃瓜"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950"></div>
              <div className="absolute inset-0 flex items-center justify-center px-4">
                <div className="text-center w-full max-w-4xl">
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
                    <i className="ri-fire-fill text-primary-400 text-sm"></i>
                    <span className="text-xs text-primary-300 font-medium">全网最新吃瓜资讯 · 实时更新</span>
                  </div>
                  <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 mb-4 leading-tight">
                    吃瓜不迷路
                    <br />
                    <span className="text-primary-400">就上51吃瓜</span>
                  </h1>
                  <p className="text-sm md:text-base text-foreground-400 max-w-2xl mx-auto mb-8 leading-relaxed">
                    全网最全娱乐八卦资讯平台，覆盖明星八卦、网红爆料、综艺热瓜、黑料实锤。
                    每日更新，精彩不停，让你吃瓜吃到饱！
                  </p>
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                    <Link
                      to="/category/trending"
                      className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm whitespace-nowrap transition-all cursor-pointer flex items-center gap-2"
                    >
                      <i className="ri-flashlight-line"></i>
                      立即吃瓜
                    </Link>
                    <Link
                      to="/category/all"
                      className="px-8 py-3 bg-background-800/80 hover:bg-background-700 text-foreground-200 font-medium rounded-full text-sm whitespace-nowrap transition-all cursor-pointer border border-background-700/50"
                    >
                      浏览全部
                    </Link>
                  </div>

                  <div className="flex items-center justify-center gap-6 mt-10 text-xs text-foreground-500">
                    <div className="flex items-center gap-1.5">
                      <i className="ri-article-line text-foreground-600"></i>
                      <span>12,580+ 篇资讯</span>
                    </div>
                    <div className="w-px h-4 bg-background-700"></div>
                    <div className="flex items-center gap-1.5">
                      <i className="ri-user-smile-line text-foreground-600"></i>
                      <span>860万+ 吃瓜群众</span>
                    </div>
                    <div className="w-px h-4 bg-background-700"></div>
                    <div className="flex items-center gap-1.5">
                      <i className="ri-timer-flash-line text-foreground-600"></i>
                      <span>24h 实时更新</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Hot Tags */}
          <section className="w-full px-4 md:px-6 -mt-10 relative z-10">
            <div className="max-w-7xl mx-auto">
              <div className="bg-background-900/90 backdrop-blur-md rounded-xl border border-background-800/50 p-4">
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="text-xs font-semibold text-primary-400 flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-hashtag"></i>
                    热门标签
                  </span>
                  {hotTags.map((tag) => (
                    <Link
                      key={tag}
                      to={`/category/all`}
                      className="px-3 py-1 text-xs rounded-full bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 border border-background-700/50 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {tag}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Featured Article */}
          <section className="w-full px-4 md:px-6 pt-10 md:pt-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                <h2 className="text-lg font-bold text-foreground-100">今日重磅</h2>
              </div>
              <ArticleCard article={featuredArticle} variant="featured" />
            </div>
          </section>

          {/* Category Tabs + Article Grid */}
          <section className="w-full px-4 md:px-6 pt-10 md:pt-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                <h2 className="text-lg font-bold text-foreground-100">最新吃瓜</h2>
              </div>

              {/* Category Tabs */}
              <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 scrollbar-hide">
                {categories.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => setActiveCategory(cat.id)}
                    className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap transition-all cursor-pointer ${
                      activeCategory === cat.id
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-800 text-foreground-400 hover:text-foreground-200 hover:bg-background-700 border border-background-700/50'
                    }`}
                  >
                    {cat.name}
                  </button>
                ))}
              </div>

              {/* Article Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {filteredArticles.slice(0, 9).map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>

              {filteredArticles.length > 9 && (
                <div className="flex justify-center mt-8">
                  <Link
                    to={`/category/${activeCategory}`}
                    className="px-6 py-2.5 bg-background-800 hover:bg-background-700 text-foreground-300 text-sm font-medium rounded-full border border-background-700/50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    查看更多 <i className="ri-arrow-right-line ml-1"></i>
                  </Link>
                </div>
              )}
            </div>
          </section>

          {/* Hot Articles Side Grid */}
          <section className="w-full px-4 md:px-6 pt-10 md:pt-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
                <h2 className="text-lg font-bold text-foreground-100">热门推荐</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {hotArticles.slice(0, 4).map((article) => (
                  <ArticleCard key={article.id} article={article} variant="compact" />
                ))}
              </div>
            </div>
          </section>

          {/* Featured Videos */}
          <section className="w-full px-4 md:px-6 pt-10 md:pt-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
                <h2 className="text-lg font-bold text-foreground-100">热门视频</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {featuredVideos.map((video) => (
                  <div key={video.id} className="group cursor-pointer">
                    <div className="relative rounded-xl overflow-hidden mb-3">
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        className="w-full aspect-video object-cover transition-transform duration-300 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/40 transition-all flex items-center justify-center">
                        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 transition-all group-hover:scale-110">
                          <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                        </div>
                      </div>
                      <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/80 text-xs text-foreground-400 whitespace-nowrap">
                        {video.duration}
                      </span>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-300 line-clamp-2 group-hover:text-primary-400 transition-colors leading-snug">
                      {video.title}
                    </h3>
                    <p className="text-xs text-foreground-600 mt-1">
                      <i className="ri-eye-line mr-1"></i>
                      {video.views} 次播放
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Latest Quick Feed */}
          <section className="w-full px-4 md:px-6 pt-10 md:pt-14 pb-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1 h-5 bg-secondary-500 rounded-full"></div>
                <h2 className="text-lg font-bold text-foreground-100">刚刚更新</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {latestArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>
          </section>

          {/* Download CTA */}
          <section className="w-full px-4 md:px-6 pb-14">
            <div className="max-w-7xl mx-auto">
              <div className="relative rounded-2xl overflow-hidden bg-gradient-to-r from-primary-600/20 via-background-900 to-accent-600/10 border border-background-800/50 p-8 md:p-12">
                <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
                  <div>
                    <h2 className="text-xl md:text-2xl font-bold text-foreground-50 mb-2">
                      随时随地，畅快吃瓜
                    </h2>
                    <p className="text-sm text-foreground-400 max-w-md">
                      下载51吃瓜APP，第一时间获取最新八卦资讯。支持iOS和Android，随时随地不错过任何精彩！
                    </p>
                  </div>
                  <div className="flex items-center gap-3">
                    <a href="#" className="flex items-center gap-2 px-5 py-3 bg-background-50 hover:bg-background-100 text-background-950 text-sm font-semibold rounded-full whitespace-nowrap transition-all cursor-pointer">
                      <i className="ri-apple-line text-lg"></i>
                      App Store
                    </a>
                    <a href="#" className="flex items-center gap-2 px-5 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold rounded-full whitespace-nowrap transition-all cursor-pointer">
                      <i className="ri-android-line text-lg"></i>
                      Android 下载
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}